import 'css-chunksrc/client/pages/documentsPage/documentsPage/preview/zipRenderer/styles.scss';export default {
  "node": "_node_1bw70_1"
};